/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import typography from "assets/theme/theme-light/base/typography";
import borders from "assets/theme/theme-light/base/borders";
import colors from "assets/theme/theme-light/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

const { size, fontWeightRegular, fontWeightMedium } = typography;
const { borderWidth, borderRadius } = borders;
const { green, dark, grey, white } = colors;

const tab = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      flex: "1 1 auto",
      textAlign: "center",
      justifyContent: "start",
      maxWidth: "unset !important",
      minWidth: 140,
      minHeight: "unset !important",
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      textTransform: "none",
      lineHeight: "inherit",
      padding: pxToRem(1),
      color: `${dark.main} !important`,
      opacity: "1 !important",
      border: `${borderWidth[1]} solid ${grey[600]}`,
      borderBottom: `${borderWidth[4]} solid ${grey[600]}`,
      borderRadius: borderRadius.md,
      margin: pxToRem(2),

      "&.Mui-selected": {
        backgroundColor: green.state,
        border: `${borderWidth[1]} solid ${green.main}`,
        borderBottom: `${borderWidth[4]} solid ${green.state}`,
        fontWeight: fontWeightMedium,

        ":hover": {
          backgroundColor: rgba(white.main, 0.2),
          borderBottom: `${borderWidth[4]} solid ${green.state}`,
        },
      },

      ":hover": {
        backgroundColor: rgba(white.main, 1),
        borderBottom: `${borderWidth[4]} solid ${green.state}`,
      },

      ":focus": {
        border: `${borderWidth[1]} solid ${green.main}`,
        borderBottom: `${borderWidth[4]} solid ${green.main}`,
        paddingRight: pxToRem(2),
      },

      "& .material-icons, .material-icons-round": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },

      "& svg": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },
    },

    labelIcon: {
      paddingTop: pxToRem(4),
    },
  },
};

export default tab;
